import React from 'react';
import { getContact, getLogoUrl, getPageContent } from './websiteStyles';

const DARK = '#14161C';
const PAPER = '#FAFAF8';
const LINE_D = 'rgba(250,250,248,0.06)';
const heading = '"Inter Tight", sans-serif';
const mono = '"JetBrains Mono", monospace';

function WebsiteFooter({ onNavigate }) {
  const c = getContact();
  const logoUrl = getLogoUrl();
  const cms = getPageContent('website_footer') || {};

  const colTitle = { fontFamily: mono, fontSize: 10, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'rgba(250,250,248,0.3)', marginBottom: 20 };
  const link = { display: 'block', color: 'rgba(250,250,248,0.45)', fontSize: 14, padding: '5px 0', background: 'none', border: 'none', cursor: 'pointer', fontFamily: heading, textDecoration: 'none', textAlign: 'left', transition: 'color 0.15s' };

  const Link = ({ to, children }) => (
    <button onClick={() => onNavigate(to)} style={link}
      onMouseEnter={e => { e.target.style.color = PAPER; }}
      onMouseLeave={e => { e.target.style.color = 'rgba(250,250,248,0.45)'; }}>
      {children}
    </button>
  );

  return (
    <footer style={{ background: DARK, color: PAPER }}>
      {/* Divider */}
      <div style={{ maxWidth: 1440, margin: '0 auto', padding: '0 24px' }}>
        <div style={{ borderTop: `1px solid ${LINE_D}` }} />
      </div>

      <div style={{ maxWidth: 1440, margin: '0 auto', padding: '56px 24px 24px' }}>
        {/* Main grid */}
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr', gap: 40, marginBottom: 48 }} className="ws-footer-grid">
          {/* Brand column */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
              {logoUrl ? (
                <img src={logoUrl} alt="" style={{ height: 28, objectFit: 'contain', filter: 'brightness(10)' }} />
              ) : (
                <>
                  <svg viewBox="0 0 28 28" style={{ width: 24, height: 24 }}>
                    <rect width="28" height="28" rx="6" fill="#fff"/>
                    <text x="14" y="20" textAnchor="middle" fill={DARK} fontSize="18" fontWeight="bold" fontFamily="system-ui">★</text>
                  </svg>
                  <span style={{ fontFamily: heading, fontSize: 18, fontWeight: 700, letterSpacing: '-0.03em', color: PAPER }}>BIGSTAR</span>
                </>
              )}
            </div>
            <div style={{ fontFamily: mono, fontSize: 9, letterSpacing: '0.12em', textTransform: 'uppercase', color: 'rgba(250,250,248,0.2)', marginBottom: 16 }}>
              UAE · Est. 2008
            </div>
            <p style={{ fontSize: 13, color: 'rgba(250,250,248,0.35)', lineHeight: 1.7, maxWidth: 300, marginBottom: 20 }}>
              {cms.description || "UAE's premium destination for pre-owned vehicles and genuine spare parts. Sharjah · Abu Dhabi."}
            </p>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              <a href={`https://wa.me/${c.whatsapp}`} target="_blank" rel="noopener noreferrer" style={{
                display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 14px', borderRadius: 8,
                border: '1px solid rgba(250,250,248,0.1)', background: 'transparent', color: 'rgba(250,250,248,0.5)',
                fontSize: 12, fontWeight: 500, textDecoration: 'none', fontFamily: heading, transition: 'border-color 0.2s',
              }}>
                <svg viewBox="0 0 24 24" fill="currentColor" style={{ width: 14, height: 14 }}><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.625.846 5.059 2.284 7.034L.789 23.492a.5.5 0 00.612.616l4.529-1.476A11.96 11.96 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22a9.94 9.94 0 01-5.33-1.543l-.372-.225-2.688.877.858-2.63-.248-.393A9.96 9.96 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/></svg>
                WhatsApp
              </a>
              <a href={`tel:${c.phone}`} style={{
                display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 14px', borderRadius: 8,
                border: '1px solid rgba(250,250,248,0.1)', background: 'transparent', color: 'rgba(250,250,248,0.5)',
                fontSize: 12, fontWeight: 500, textDecoration: 'none', fontFamily: heading,
              }}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" style={{ width: 14, height: 14 }}><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>
                {c.phone || c.mobile}
              </a>
            </div>
          </div>

          {/* Inventory */}
          <div>
            <div style={colTitle}>Inventory</div>
            <Link to="website-used-cars">All cars</Link>
            <Link to="website-used-cars">Featured</Link>
            <Link to="website-used-cars">Newly arrived</Link>
            <Link to="website-used-cars">Reserved</Link>
            <Link to="website-used-cars">Sold archive</Link>
          </div>

          {/* Spare Parts */}
          <div>
            <div style={colTitle}>Spare Parts</div>
            <Link to="website-spare-parts">Engine</Link>
            <Link to="website-spare-parts">Brakes</Link>
            <Link to="website-spare-parts">Suspension</Link>
            <Link to="website-spare-parts">Electrical</Link>
            <Link to="website-spare-parts">Body & Lighting</Link>
          </div>

          {/* Company */}
          <div>
            <div style={colTitle}>Company</div>
            <Link to="website-about">About</Link>
            <Link to="website-about">Locations</Link>
            <Link to="website-trade-apply">Become a Buyer</Link>
            <Link to="website-about">Press</Link>
            <Link to="website-about">Careers</Link>
          </div>

          {/* Support */}
          <div>
            <div style={colTitle}>Support</div>
            <Link to="website-contact">Contact</Link>
            <Link to="website-contact">WhatsApp</Link>
            <Link to="website-contact">Inquiry status</Link>
            <Link to="website-contact">Shipping</Link>
            <Link to="website-contact">FAQ</Link>
          </div>
        </div>

        {/* Copyright bar */}
        <div style={{ borderTop: `1px solid ${LINE_D}`, padding: '20px 0 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
          <span style={{ fontFamily: mono, fontSize: 10, letterSpacing: '0.08em', color: 'rgba(250,250,248,0.2)', textTransform: 'uppercase' }}>
            &copy; {new Date().getFullYear()} {cms.copyright_text || c.name + ' · Sharjah'}
          </span>
          <div style={{ display: 'flex', gap: 20 }}>
            {(cms.bottom_links || [{ label: 'Privacy', enabled: true }, { label: 'Terms', enabled: true }, { label: 'Cookie policy', enabled: false }])
              .filter(l => l.enabled !== false).map(l => (
              <span key={l.label} style={{ fontFamily: heading, fontSize: 12, color: 'rgba(250,250,248,0.25)', cursor: 'pointer' }}
                onMouseEnter={e => { e.target.style.color = 'rgba(250,250,248,0.5)'; }}
                onMouseLeave={e => { e.target.style.color = 'rgba(250,250,248,0.25)'; }}>
                {l.label}
              </span>
            ))}
          </div>
        </div>

        {/* Powered by */}
        <div style={{ textAlign: 'center', padding: '12px 0 4px', borderTop: `1px solid ${LINE_D}` }}>
          <span style={{ fontFamily: mono, fontSize: 9, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'rgba(250,250,248,0.12)' }}>
            Powered by <span style={{ color: 'rgba(250,250,248,0.2)' }}>★</span> BITS
          </span>
        </div>
      </div>

      <style>{`
        @media (max-width: 840px) {
          .ws-footer-grid { grid-template-columns: 1fr 1fr !important; }
          .ws-footer-grid > div:first-child { grid-column: span 2; }
        }
        @media (max-width: 500px) {
          .ws-footer-grid { grid-template-columns: 1fr !important; }
          .ws-footer-grid > div:first-child { grid-column: span 1; }
        }
      `}</style>
    </footer>
  );
}

export default WebsiteFooter;
